@if(hasAccess() === true){
  @if(userSpecialties$ | async; as userSpecialties){
    <app-page-well class="form-controls">
      <div class="filters">
        <app-grouped-select-menu
          inputId="specialtyTypesDropdown"
          name="specialty-types-dropdown"
          label="Specialty"
          [hasPlaceholderOption]="false"
          [optionGroup]="userSpecialties$ | async"
          [disabledGroup]="disabledSpecialties$ | async"
          [disabledLabel]="'Additional Specialties'"
          [selectedOption]="specialty"
          (changeEvent)="selectSpecialty($event)"
        >
        </app-grouped-select-menu>
        <app-grouped-select-menu
          inputId="regionTypesDropdown"
          name="region-types-dropdown"
          label="Region"
          placeholder="Nationwide"
          [optionGroup]="userRegions$ | async"
          [disabledGroup]="disabledRegions$ | async"
          [disabledLabel]="'Additional Regions'"
          [selectedOption]="region"
          (changeEvent)="selectRegionOption($event)"
        >
        </app-grouped-select-menu>
        <lib-radios
          [formControlProperty]="productionBonus"
          [radioInputs]="productionBonusOptions"  
        >
          <label>Production Bonus</label>
        </lib-radios>
      </div>
    </app-page-well>

    @if(rData$ | async; as rData){
      <app-page-well *ngIf="specialty">
        <div class="table-wrapper">
          <div class="main-table-wrapper">
            <table
              class="r-data__table"
              *ngIf="productionBonus.value === 'Wrvu'; else collectionsTable"
            >
              <thead class="r-data__table-header">
                <tr>
                  <th id="empty-column-header"></th>
                  <th>
                    <p class="bold-th">Salary</p>
                  </th>
                  <th>
                    <p>wRVU Threshold</p>
                  </th>
                  <th>
                    <p>$/wRVU</p>
                  </th>
                  <th>
                    <p>Signing Bonus</p>
                  </th>
                  <th>
                    <p>Relocation Bonus</p>
                  </th>
                  <th>
                    <p>CME Allowance</p>
                  </th>
                  <th>
                    <p>PTO Weeks</p>
                  </th>
                  <th>
                    <p>Non-compete Miles</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="r-data__table-row--name">
                    <p><span class="bold-td">10th</span> Percentile</p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.salaryQuartiles.percentile10 | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.wrvuThresholdQuartiles.percentile10 | number:'1.0-2'
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.dollarsPerWrvuQuartiles.percentile10
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.signingBonusQuartiles.percentile10
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.relocationBonusQuartiles.percentile10
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.cmeAllowanceQuartiles.percentile10
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parsePto(rData.ptoHoursQuartiles.percentile10 | number:'1.0-2')
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.nonCompeteMilesQuartiles.percentile10 | number:'1.0-2'
                        )
                      }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td class="r-data__table-row--name">
                    <p><span class="bold-td">25th</span> Percentile</p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.salaryQuartiles.percentile25 | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.wrvuThresholdQuartiles.percentile25 | number:'1.0-2'
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.dollarsPerWrvuQuartiles.percentile25
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.signingBonusQuartiles.percentile25
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.relocationBonusQuartiles.percentile25
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.cmeAllowanceQuartiles.percentile25
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parsePto(rData.ptoHoursQuartiles.percentile25 | number:'1.0-2')
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.nonCompeteMilesQuartiles.percentile25 | number:'1.0-2'
                        )
                      }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td class="r-data__table-row--name">
                    <p><span class="bold-td">Median</span></p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(rData.salaryQuartiles.median | displayCurrency)
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(rData.wrvuThresholdQuartiles.median | number:'1.0-2')
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.dollarsPerWrvuQuartiles.median
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.signingBonusQuartiles.median | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.relocationBonusQuartiles.median | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.cmeAllowanceQuartiles.median | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{ parsePto(rData.ptoHoursQuartiles.median | number:'1.0-2') }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(rData.nonCompeteMilesQuartiles.median | number:'1.0-2')
                      }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td class="r-data__table-row--name">
                    <p><span class="bold-td">75th</span> Percentile</p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.salaryQuartiles.percentile75 | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.wrvuThresholdQuartiles.percentile75 | number:'1.0-2'
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.dollarsPerWrvuQuartiles.percentile75
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.signingBonusQuartiles.percentile75
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.relocationBonusQuartiles.percentile75
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.cmeAllowanceQuartiles.percentile75
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parsePto(rData.ptoHoursQuartiles.percentile75 | number:'1.0-2')
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.nonCompeteMilesQuartiles.percentile75 | number:'1.0-2'
                        )
                      }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td class="r-data__table-row--name">
                    <p><span class="bold-td">90th</span> Percentile</p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.salaryQuartiles.percentile90 | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.wrvuThresholdQuartiles.percentile90 | number:'1.0-2'
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.dollarsPerWrvuQuartiles.percentile90
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.signingBonusQuartiles.percentile90
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.relocationBonusQuartiles.percentile90
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.cmeAllowanceQuartiles.percentile90
                            | displayCurrency
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parsePto(rData.ptoHoursQuartiles.percentile90 | number:'1.0-2')
                      }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{
                        parseStats(
                          rData.nonCompeteMilesQuartiles.percentile90 | number:'1.0-2'
                        )
                      }}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>

            <ng-template #collectionsTable>
              <table class="r-data__table">
                <thead>
                  <tr>
                    <th id="empty-column-header"></th>
                    <th>
                      <p>Salary</p>
                    </th>
                    <th>
                      <p>Collections Threshold</p>
                    </th>
                    <th>
                      <p>Production Bonus Ratio</p>
                    </th>
                    <th>
                      <p>Signing Bonus</p>
                    </th>
                    <th>
                      <p>Relocation Bonus</p>
                    </th>
                    <th>
                      <p>CME Allowance</p>
                    </th>
                    <th>
                      <p>PTO Weeks</p>
                    </th>
                    <th>
                      <p>Non-compete Miles</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="r-data__table-row--name">
                      <p><span class="bold-td">10th</span> Percentile</p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.salaryQuartiles.percentile10 | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.collectionsThresholdQuartiles.percentile10
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.productionBonusRatioQuartiles.percentile10
                              | rdata:'productionBonusRatio':'Dollars'
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.signingBonusQuartiles.percentile10
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.relocationBonusQuartiles.percentile10
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.cmeAllowanceQuartiles.percentile10
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parsePto(rData.ptoHoursQuartiles.percentile10 | number:'1.0-2')
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.nonCompeteMilesQuartiles.percentile10 | number:'1.0-2'
                          )
                        }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td class="r-data__table-row--name">
                      <p><span class="bold-td">25th</span> Percentile</p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.salaryQuartiles.percentile25 | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.collectionsThresholdQuartiles.percentile25
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.productionBonusRatioQuartiles.percentile25
                              | rdata:'productionBonusRatio':'Dollars'
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.signingBonusQuartiles.percentile25
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.relocationBonusQuartiles.percentile25
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.cmeAllowanceQuartiles.percentile25
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parsePto(rData.ptoHoursQuartiles.percentile25 | number:'1.0-2')
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.nonCompeteMilesQuartiles.percentile25 | number:'1.0-2'
                          )
                        }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td class="r-data__table-row--name">
                      <p><span class="bold-td">Median</span></p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.salaryQuartiles.median | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.collectionsThresholdQuartiles.median
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.productionBonusRatioQuartiles.median | rdata:'productionBonusRatio':'Dollars'
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.signingBonusQuartiles.median | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.relocationBonusQuartiles.median
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.cmeAllowanceQuartiles.median | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{ parsePto(rData.ptoHoursQuartiles.median | number:'1.0-2') }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.nonCompeteMilesQuartiles.median | number:'1.0-2'
                          )
                        }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td class="r-data__table-row--name">
                      <p><span class="bold-td">75th</span> Percentile</p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.salaryQuartiles.percentile75 | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.collectionsThresholdQuartiles.percentile75
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.productionBonusRatioQuartiles.percentile75
                              | rdata:'productionBonusRatio':'Dollars'
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.signingBonusQuartiles.percentile75
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.relocationBonusQuartiles.percentile75
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.cmeAllowanceQuartiles.percentile75
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parsePto(rData.ptoHoursQuartiles.percentile75 | number:'1.0-2')
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.nonCompeteMilesQuartiles.percentile75 | number:'1.0-2'
                          )
                        }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td class="r-data__table-row--name">
                      <p><span class="bold-td">90th</span> Percentile</p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.salaryQuartiles.percentile90 | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.collectionsThresholdQuartiles.percentile90
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.productionBonusRatioQuartiles.percentile90
                              | rdata:'bonusRate':'Dollars'
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.signingBonusQuartiles.percentile90
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.relocationBonusQuartiles.percentile90
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.cmeAllowanceQuartiles.percentile90
                              | displayCurrency
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parsePto(rData.ptoHoursQuartiles.percentile90 | number:'1.0-2')
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          parseStats(
                            rData.nonCompeteMilesQuartiles.percentile90 | number:'1.0-2'
                          )
                        }}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-template>
          </div>
        </div>
      </app-page-well>
    }
  }
}
@else {
  <app-no-access></app-no-access>
}
<ng-template #loaderTemplate>
  <lib-loader containerCustomStyle="custom-loader"></lib-loader>
</ng-template>
